import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.system.background.xWeak};
	padding: ${({ theme }) => theme.spacing.large};
`;

export const Card = styled.div`
	background: ${({ theme }) => theme.colors.system.background.white};
	border-radius: ${({ theme }) => theme.shapeRadius.medium};
	padding: ${({ theme }) => `${theme.spacing.xxl} ${theme.spacing.xl}`};
	max-width: 500px;
	width: 100%;
	box-shadow: ${({ theme }) => theme.shadows.elevation.medium};
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: ${({ theme }) => theme.spacing.xs};
`;

export const IconContainer = styled.div`
	margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const EmailIcon = styled.div`
	font-size: 48px;
`;

export const SuccessIcon = styled.div`
	width: 64px;
	height: 64px;
	border-radius: ${({ theme }) => theme.shapeRadius[50]};
	background-color: ${({ theme }) => theme.colors.success.background.default};
	color: ${({ theme }) => theme.colors.system.background.white};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${({ theme }) => theme.fonts.sizes.xxl};
	font-weight: bold;
`;

export const ErrorIcon = styled.div`
	width: 64px;
	height: 64px;
	border-radius: ${({ theme }) => theme.shapeRadius[50]};
	background-color: ${({ theme }) => theme.colors.error.background.default};
	color: ${({ theme }) => theme.colors.system.background.white};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${({ theme }) => theme.fonts.sizes.xxl};
	font-weight: bold;
`;

export const Description = styled.div`
	margin: ${({ theme }) => `${theme.spacing.medium} 0`};
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacing.xs};
`;

export const ButtonContainer = styled.div`
	margin-top: ${({ theme }) => theme.spacing.large};
	display: flex;
	gap: ${({ theme }) => theme.spacing.small};
	justify-content: center;
`;

export const LoaderContainer = styled.div`
	margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const ErrorText = styled.div`
	margin-top: ${({ theme }) => theme.spacing.small};
`;

export const EmailBadge = styled.div`
	background-color: ${({ theme }) => theme.colors.system.background.xWeak};
	border-radius: ${({ theme }) => theme.shapeRadius.small};
	padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.medium}`};
	word-break: break-all;
`;
